import { Col, Form, Row } from 'antd';
import moment from 'moment';
import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { FilterRevenueDTO } from '../filter-revenue.dto';

import { RefreshIcon, SearchIcon } from '@/assets/icons';
import ButtonWrap from '@/components/ButtonWrap';
import CheckBoxWrap from '@/components/CheckBoxWrap';
import DatePickerWrap from '@/components/DatePickerWrap';
import FormItemWrap from '@/components/FormItemWrap';
import FranchiseStoreFilters from '@/components/FranchiseStoreFilters';
import IconWrap from '@/components/IconWrap';
interface IProps {
    onHandleData: (data: FilterRevenueDTO) => void;
    onClearData: () => void;
}
const Header: React.FC<IProps> = ({ onHandleData, onClearData }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const {
        handleSubmit,
        setValue,
        reset,
        control,
        formState: { errors },
        clearErrors,
    } = useFormContext<FilterRevenueDTO>();

    const onSubmit = (data: FilterRevenueDTO) => {
        if (moment(data.date).isValid()) {
            data.date = moment(data.date).format('YYYY/MM/DD');
        }
        onHandleData(data);
    };

    const onReset = () => {
        queryClient.removeQueries('stores');
        onClearData();
        reset();
    };
    return (
        <div className="p-product-daily-report-header">
            <Form onFinish={handleSubmit(onSubmit)}>
                <Row gutter={{ xxl: 20 }}>
                    <Col span={24} xxl={18}>
                        <Row gutter={16}>
                            <FranchiseStoreFilters
                                errors={errors}
                                clearErrors={clearErrors}
                                propsCol={{ span: 24, md: 9, xl: 6 }}
                                setValue={setValue}
                                control={control}
                            />
                            <Col span={24} md={8} xl={6}>
                                <FormItemWrap
                                    required
                                    labelAlign="left"
                                    label={t('SALE_DATE')}
                                    colon={false}
                                    validateStatus={errors?.date ? 'error' : ''}
                                    help={
                                        String(errors?.date?.type) === 'required' &&
                                        t('VALIDATION.REQUIRED_FILL', { name: t('SALE_DATE') })
                                    }
                                >
                                    <Controller
                                        name="date"
                                        control={control}
                                        rules={{
                                            required: true,
                                        }}
                                        render={({ field }) => <DatePickerWrap field={field} suffixIcon />}
                                    />
                                </FormItemWrap>
                            </Col>
                            <Col span={24} md={8} xl={6}>
                                <FormItemWrap labelAlign="left" label={t('AKADEN_ONLY')} colon={false}>
                                    <Controller
                                        name="redSlip"
                                        defaultValue={false}
                                        control={control}
                                        render={({ field }) => <CheckBoxWrap field={field} />}
                                    />
                                </FormItemWrap>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} xxl={6}>
                        <Row gutter={16}>
                            <Col span={12} xl={{ span: 6, offset: 6 }} xxl={{ span: 12, offset: 0 }}>
                                <ButtonWrap
                                    icon={<RefreshIcon />}
                                    width="100%"
                                    onClick={onReset}
                                    text={`${t('CLEAR')}`}
                                />
                            </Col>
                            <Col span={12} xl={{ span: 6 }} xxl={12}>
                                <ButtonWrap
                                    icon={<IconWrap icon={<SearchIcon />} />}
                                    text={`${t('SEARCH')}`}
                                    type="primary"
                                    width="100%"
                                    htmlType="submit"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default memo(Header);
